import { render, staticRenderFns } from "./SueldosEmpresaLayout.vue?vue&type=template&id=ad25c4de&scoped=true&"
import script from "./SueldosEmpresaLayout.vue?vue&type=script&lang=js&"
export * from "./SueldosEmpresaLayout.vue?vue&type=script&lang=js&"
import style0 from "./SueldosEmpresaLayout.vue?vue&type=style&index=0&id=ad25c4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad25c4de",
  null
  
)

export default component.exports